import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { RootState } from '../../store';
import { SidebarState } from '../../store/sidebar/types';
import Connecting from '../Connecting';
import Dialpad from '../Dialpad';
import IncomingCallJoin from '../IncomingCall';
import OutboundCallConnecting from '../OutboundCallConnecting';
import OutboundCallJoin from '../OutboundCallJoin';
import SideBoxMenu from '../SideBoxMenu';
import CustomerRating from '../CustomerRating';
import ServiceDirectory from '../ServiceDirectory/ServiceDirectory';
import { useCall } from '../../customer-call-sdk';

const StyledSideBox = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.14);
    overflow: hidden;
`;

/**
 * Side box component
 */
function SideBox() {
    const call = useCall();
    const { isConnecting, isOutgoingCall, isJoining, isIncomingCall, isRatingAvailable } = call;

    const { screen } = useSelector<RootState, SidebarState>((state) => state.sidebar);

    const renderSideBoxScreen = () => {
        if (isJoining && isOutgoingCall) {
            return <OutboundCallJoin />;
        }

        if (isConnecting && isOutgoingCall) {
            return <OutboundCallConnecting />;
        }

        if (isJoining && isIncomingCall) {
            return <IncomingCallJoin />;
        }

        if (isConnecting) {
            return <Connecting />;
        }
        if (isRatingAvailable) {
            return <CustomerRating />;
        }
        if (!isConnecting && screen === 'serviceDirectory') {
            return <ServiceDirectory />;
        }
        if (screen === 'dialpad') {
            return <Dialpad />;
        }
        return <SideBoxMenu />;
    };
    return <StyledSideBox>{renderSideBoxScreen()}</StyledSideBox>;
}

export default SideBox;
